import React, { ReactNode } from 'react';

import { BgRow } from '@infoods/lifebase-ui';

import classes from './BannerBgRow.module.scss';

type BannerBgRowProps = {
  children: ReactNode;
};

// image as background instead of <img> so the inset box-shadow is visible:
// inset shadow paints above the background layer but under a replaced element's content
const BannerBgRow = ({ children }: BannerBgRowProps) => {
  return <BgRow background={<div className={classes.background} />}>{children}</BgRow>;
};

export { BannerBgRow };
